import groove from 'api/groove'
import { oauthTokenSelector } from 'selectors/app'
import { selectCurrentCustomerId } from 'selectors/tickets'

import { selectHasLoadedAll } from '../selectors'
import {
  FETCH_TICKETS_REQUEST,
  FETCH_TICKETS_RESPONSE,
  FETCH_TICKETS_ERROR,
} from '../types'

export function doLoadRecentTicketsForCurrentCustomer() {
  return (dispatch, getState) => {
    const customerId = selectCurrentCustomerId(getState())
    dispatch(doLoadAllRecentTickets(customerId))
  }
}
export function doLoadRecentTickets(customerId, options = {}) {
  return doLoadTickets(customerId, { perPage: 4, ...options })
}

export function doLoadAllRecentTickets(customerId) {
  return doLoadTickets(customerId, { perPage: 50 })
}

function getTicketState({ snoozed_until: snoozedUntil, state }) {
  if (snoozedUntil) return 'snoozed'

  return state
}
function doLoadTickets(customerId, { perPage, page = 1, silent }) {
  return (dispatch, getState) => {
    const state = getState()
    const token = oauthTokenSelector(state)
    const hasLoadedAll = selectHasLoadedAll(state, customerId)

    if (hasLoadedAll) return

    dispatch(doLoadRecentTicketsRequest(customerId, silent))

    groove
      .get(token, 'v1/tickets/search', {
        customer: customerId,
        per_page: perPage,
        page,
        order: 'updated_at desc',
        full_tickets: true,
      })
      .then(result => {
        const {
          tickets: rawTickets,
          meta: { pagination },
        } = result.json

        const loadedAll =
          pagination.current_page === pagination.total_pages ||
          pagination.current_page * perPage >= 50
        const tickets = rawTickets.map(ticket => ({
          id: parseInt(ticket.number, 10),
          // Has to be snoozed_until because its loading directly from the api
          state: getTicketState(ticket),
          title: ticket.title,
          assignee: ticket.assignee && ticket.assignee.username,
          updatedAt: ticket.updated_at,
        }))

        dispatch(doLoadRecentTicketsResponse(customerId, tickets, loadedAll))
      })
      .catch(err => {
        dispatch(doLoadRecentTicketsError(err))
      })
  }
}

function doLoadRecentTicketsRequest(customerId, silent) {
  return {
    type: FETCH_TICKETS_REQUEST,
    payload: {
      customerId,
      silent,
    },
  }
}

function doLoadRecentTicketsResponse(customerId, tickets, loadedAll) {
  return {
    type: FETCH_TICKETS_RESPONSE,
    payload: {
      customerId,
      tickets,
      loadedAll,
    },
  }
}

function doLoadRecentTicketsError(error) {
  return {
    type: FETCH_TICKETS_ERROR,
    payload: {
      error,
    },
  }
}
